// extracted by mini-css-extract-plugin
export default {"app__wrapper":"app_app__wrapper__0XQSp","appHeader":"app_appHeader__74CbF","content__wrapper":"app_content__wrapper__FanT4","emptyText":"app_emptyText__Mpn1z"};